// To top
document.addEventListener("DOMContentLoaded", function() {
    const scrollToTopBtn = document.getElementById("to-top");

    window.onscroll = function() {
        scrollFunction();
    };

    function scrollFunction() {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 150) {
            scrollToTopBtn.style.display = "flex";
            scrollToTopBtn.style.justifyContent = "center";
            scrollToTopBtn.style.alignItems = "center";

        } else {
            scrollToTopBtn.style.display = "none";
        }
    }

    scrollToTopBtn.addEventListener("click", function() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    });
});

// Tabs
document.addEventListener('DOMContentLoaded', function () {
    const tabLinks = document.querySelectorAll('.info-tabs__link');
    const tabs = document.querySelectorAll('.info-tab');

    tabLinks.forEach(link => {
        link.addEventListener('click', function () {
            tabLinks.forEach(link => link.classList.remove('active'));
            tabs.forEach(tab => tab.classList.remove('active'));

            this.classList.add('active');
            const tabId = this.getAttribute('data-tab');
            document.querySelector(`.info-tab[data-tab="${tabId}"]`).classList.add('active');
        });
    });
});

// Adding a file to the form
document.addEventListener('DOMContentLoaded', function () {
    const fileInput = document.getElementById('file-input');
    const fileNameField = document.querySelector('.file-name');

    if (fileInput && fileNameField) {
        fileInput.addEventListener('change', function () {
            if (this.files.length > 0) {
                fileNameField.value = this.files[0].name;
            } else {
                fileNameField.value = '';
            }
        });
    }
});

// Showing/hiding dropdown
document.addEventListener('DOMContentLoaded', function () {
    const menuItem = document.querySelector('.menu-item-414 a, .menu-item-545 a');
    const dropdown = document.querySelector('.dropdown');
    let timer;

    function isWideEnough() {
        return window.innerWidth > 1200;
    }

    function showDropdown() {
        if (!isWideEnough()) return;
        clearTimeout(timer);
        dropdown.style.visibility = 'visible';
        dropdown.style.opacity = '1';
        menuItem.classList.add('active');
    }

    function hideDropdown() {
        if (!isWideEnough()) return;
        dropdown.style.opacity = '0';
        timer = setTimeout(function () {
            dropdown.style.visibility = 'hidden';
            menuItem.classList.remove('active');
        }, 300);
    }

    menuItem.addEventListener('mouseenter', showDropdown);
    menuItem.addEventListener('mouseleave', function () {
        timer = setTimeout(hideDropdown, 100);
    });

    dropdown.addEventListener('mouseenter', showDropdown);
    dropdown.addEventListener('mouseleave', hideDropdown);
});
